<template>
  <div class="content">
    <crumbs :activeIndex="7"></crumbs>
    <div class="login">
      <img src="../../static/img/loginpost.png" alt />
    </div>
    <!-- <div class="login-roof">
      <div class="roof">
        <div class="roof-left">
           <router-link :to="{ path:'/'}" >
          <span>官网首页</span></router-link>
        </div>
        <div class="roof-right">
           <router-link :to="{ path:'/booking'}" >
          <span>个人中心</span></router-link>
        </div>
      </div>
    </div> -->
    <div class="register">
       <enter></enter>
    </div>
      <tab></tab>
    <!-- 底部 start-->
    <Footer></Footer>
  </div>
</template>
<script>
import enter from "../components/enter.vue"
import crumbs from "@/components/header";
import tab from "@/components/tab.vue";
 export default {
     components:{
        enter,
        crumbs,
        tab
      
     },
    data() {
      return {
       show:true,
       login:""
      };
    },
    methods: {
    
    }
  }
</script>
<style scoped>
.content {
  width: 100vw;
  height: 100vh;
}
.login{
  width: 100vw;
  height: 580px;
}
.login img {
  width: 100vw;
  height: 580px;
  background-repeat:no-repeat;
  background-size: 100% 100%;
}
.login-roof {
  content: "";
  width: 100%;
  height: 35px;
  top: 0;
  position: absolute;
  /* z-index: -1; */
  margin: 0 auto;
  background: #f3f3f3;
}
.roof {
  width: 90%;
  height: 35px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.roof-left,
.roof-right {
  width: 150px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  color: #999;
  font-size: 14px;
}
.register{
   position: absolute;
    top: 165px;
    /* margin-top: -135px; */
    right: 0;
    right: 126px;
    /* right: 0; */
    width:440px;
    height: 410px;
    background: #fff;
    float: right;
    margin: 0em 0;
    /* padding: 40px 20px; */
    /* padding-right: 30px; */
    border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/view/enters.vue